<h2 class="title">Nasi partnerzy</h2>

<app-offer-menu [context]="'partners'" [selectedGroupId]="selectedGroup" (groupSelected)="onGroupChange($event)"></app-offer-menu>

@if (items$ | async; as items) {
  @if (items) {
    <div>
      @if (!(items.total > 0)) {
        <div class="no-news">
          Brak rekordów do wyświetlenia.
        </div>
      }
      @if (items.total > 0) {
        <div class="partners-grid">
          @for (partner of items?.items; track partner) {
            <app-partnerspartner-view
              [attr.data-item-id]="partner.id"
              (click)="goToPartnerDetails(partner.id, partner.name)"
              class="partner-item"
              [partner]="partner">
            </app-partnerspartner-view>
          }
        </div>
      }
    </div>
  }
}